export default __webpack_public_path__ + "static/media/warning--go-right--g1.39eb9a50.png";